import(/* webpackMode: "eager" */ "/app/node_modules/react-perfect-scrollbar/dist/css/styles.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/iconify-icons/generated-icons.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LangRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PrefetchStaticPaths.tsx");
